import {h, render} from 'preact';
import './style.scss';

const Depends = () => {
 return (
   <div className="depends">
     <strong>The cost of your order depends on the:</strong>
     <div className="depends__list">
       <div className="depends__list__item">
         <svg width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="https://www.w3.org/2000/svg">
           <path d="M22.5 7.22119L12.5672 11.5218L1 6.28254L12.5672 1L25 5.72119V14.2368" stroke="#111743" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M26.6607 16.4589C26.6607 17.3761 25.9172 18.1196 25 18.1196C24.0828 18.1196 23.3393 17.3761 23.3393 16.4589C23.3393 15.5417 24.0828 14.7982 25 14.7982C25.9172 14.7982 26.6607 15.5417 26.6607 16.4589Z" stroke="#111743" stroke-width="1.6" stroke-linecap="round"/>
           <path d="M4.18515 8.22986V13.831L12.5004 17.3922L20.9587 13.7273V8.55929" stroke="#111743" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
         </svg>
         Discipline
       </div>
       <div className="depends__list__item">
         <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="https://www.w3.org/2000/svg">
           <path d="M12.125 1H3.225C2.63489 1 2.06896 1.23442 1.65169 1.65169C1.23442 2.06896 1 2.63489 1 3.225V21.025C1 21.6151 1.23442 22.181 1.65169 22.5983C2.06896 23.0156 2.63489 23.25 3.225 23.25H16.575C17.1651 23.25 17.731 23.0156 18.1483 22.5983C18.5656 22.181 18.8 21.6151 18.8 21.025V7.675L12.125 1Z" stroke="#111743" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M12.125 1V7.675H18.8" stroke="#111743" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M14.35 13.2375H5.45001" stroke="#111743" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M14.35 17.6875H5.45001" stroke="#111743" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
           <path d="M7.67501 8.78748H5.45001" stroke="#111743" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
         </svg>
         Task Size
       </div>
       <div className="depends__list__item">
         <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="https://www.w3.org/2000/svg">
           <g clip-path="url(#clip0)">
             <path d="M19.6851 5.7887C19.2294 6.00914 19.0387 6.55743 19.2592 7.01286C19.8614 8.25694 20.1667 9.59792 20.1667 11C20.1667 16.0544 16.0544 20.1667 11 20.1667C5.94558 20.1667 1.83333 16.0544 1.83333 11C1.83333 5.94558 5.94558 1.83333 11 1.83333C13.0945 1.83333 15.0621 2.51725 16.6907 3.81101C17.0857 4.12634 17.6633 4.06032 17.9786 3.66398C18.2939 3.26786 18.2279 2.69092 17.8314 2.37604C15.9034 0.843709 13.4772 0 11 0C4.93492 0 0 4.93492 0 11C0 17.0651 4.93492 22 11 22C17.0651 22 22 17.0651 22 11C22 9.3193 21.633 7.70864 20.9092 6.21458C20.6892 5.75804 20.1391 5.56781 19.6851 5.7887Z" fill="#111743"/>
             <path d="M11 3.66663C10.494 3.66663 10.0833 4.07729 10.0833 4.58329V11C10.0833 11.506 10.494 11.9166 11 11.9166H15.5833C16.0893 11.9166 16.5 11.506 16.5 11C16.5 10.494 16.0893 10.0833 15.5833 10.0833H11.9167V4.58329C11.9167 4.07729 11.506 3.66663 11 3.66663Z" fill="#111743"/>
           </g>
           <defs>
             <clipPath id="clip0">
               <rect width="22" height="22" fill="white"/>
             </clipPath>
           </defs>
         </svg>
         Deadline
       </div>
     </div>
   </div>
 );
};

export default Depends;
